var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C16.142 22 19.5 18.642 19.5 14.5C19.5 7.5 12 2 12 2C12 2 4.5 7.5 4.5 14.5C4.5 18.642 7.858 22 12 22Z",
    stroke: "#EE7225",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.5002C4.5 18.6422 7.858 22.0002 12 22.0002C16.142 22.0002 19.5 18.6422 19.5 14.5002C19.5 14.5002 15 16.0002 12 14.5002C9 13.0002 4.5 14.5002 4.5 14.5002Z",
    fill: "#EE7225",
    stroke: "#EE7225",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrix);
export default __webpack_public_path__ + "static/media/brix.4072cac649408ef346aadf23529008ed.svg";
export { ForwardRef as ReactComponent };